import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfigurableDialog, DialogModule, DialogService } from '@proget-shared/dialog';
import { FormControlErrorModule } from '@proget-shared/form/form-control-error';
import { FormControlLabelModule } from '@proget-shared/form/form-control-label';
import { FormHelperModule } from '@proget-shared/form/helper';
import { InputModule } from '@proget-shared/form/input';
import { ResponseErrorForm, ResponseErrorTemplateMapper } from '@proget-shared/helper/response-error';
import { PipeModule } from '@proget-shared/pipe';
import { TranslateModule } from '@proget-shared/translate';
import { ToastService } from '@proget-shared/ui/toast';

import { Attribute, User } from '../../model';
import { UserCardRepository } from '../../user-card.repository';

@Component({
  selector: 'lib-attribute-value-dialog',
  templateUrl: './attribute-value-dialog.component.html',
  imports: [
    ReactiveFormsModule,
    DialogModule,
    InputModule,
    FormControlLabelModule,
    FormControlErrorModule,
    FormHelperModule,
    PipeModule,
    TranslateModule,
  ],
})
export class AttributeValueDialogComponent implements ConfigurableDialog {
  protected readonly form: FormGroup = null;

  protected errors: ResponseErrorForm = {};
  protected attribute: Attribute = null;

  private readonly dialog = inject(DialogService);
  private readonly toastService = inject(ToastService);
  private readonly userCardRepository = inject(UserCardRepository);

  private user: User = null;

  constructor() {
    this.form = inject(FormBuilder).group({
      value: [null],
    });
  }

  onConfiguration(configuration: { items: Attribute[]; user: User }): void {
    this.attribute = configuration.items[0];
    this.user = configuration.user;
    this.form.patchValue({
      value: this.attribute.value,
    });

    this.attribute.key === 'User:Mobile'
      ? this.form.get('value').setValidators(Validators.pattern(/^(\+|\d)[0-9]{7,16}$/))
      : this.form.get('value').setValidators(Validators.maxLength(128));
  }

  protected close(): void {
    this.dialog.reject(this);
  }

  protected submit({ valid, value }: FormGroup): void {
    if (!valid) {
      return;
    }

    this.userCardRepository.updateAttributeValue(
      this.user.uuid,
      this.attribute.key,
      value.value
    )
      .subscribe({
        next: () => {
          this.dialog.resolve(this);
        },
        error: (errors) => {
          this.toastService.error(
            'library.user_card.attributes.change_value.toast.error',
            ResponseErrorTemplateMapper.map(errors.messages)
          );
          this.errors = errors.form;
        },
      });
  }
}
